import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {connect} from 'react-redux';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {ApplicationStoreType} from 'desktop/store';

import {setShowSavedCards} from '../../store/reducers/paymentStep/creditCard/creditCard';
import {getShowSavedCards} from '../../store/selectors/creditCard/creditCard';

import s from './savedCardsSwitcher.scss';

export type PropsType = {
    isSavedCardsShown: boolean;
    showSavedCards: (show: boolean) => void;
};

/**
 * Switcher between card form and saved cards list
 * for credit card payment method on checkout
 *
 * @constructor
 */
export const SavedCardsSwitcher: React.FC<PropsType> = ({isSavedCardsShown, showSavedCards}) => {
    const buttonText = `use ${isSavedCardsShown ? 'different' : 'saved'} card`;

    const handleClick = () => {
        sendDesktopAnalyticsEvent(CHECKOUT_PAYMENT_STEP, {
            message: `CTA - ${buttonText}`,
            method: 'Payment',
        });
        showSavedCards(!isSavedCardsShown);
    };

    return (
        <div className={s.switcher}>
            Or,{' '}
            <button
                className={s.switcherButton}
                data-test-name="useDiffCard"
                onClick={handleClick}
                type="button"
            >
                {buttonText}
            </button>
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    isSavedCardsShown: getShowSavedCards(store),
});

export const SavedCardsSwitcherConnected = connect(mapStateToProps, {
    showSavedCards: setShowSavedCards,
})(SavedCardsSwitcher);
